module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Light.4e8ef1d9.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Light.woff2
// module id = 324
// module chunks = 3